import { render, staticRenderFns } from "./DashboardProfileCard.vue?vue&type=template&id=ddb3f4ce"
import script from "./DashboardProfileCard.vue?vue&type=script&lang=js"
export * from "./DashboardProfileCard.vue?vue&type=script&lang=js"
import style0 from "./DashboardProfileCard.vue?vue&type=style&index=0&id=ddb3f4ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports